/**
 * 规则页拿哪一期当例子。
 *
 * <p>整页共用<b>一期真实的整点档开奖</b>：一个整点档期同时也是一个 5 分钟期，
 * 所以一期就能同时喂饱区块演算、Milhar 卡片和 Milhar Hora 卡片，两张卡片上的
 * 结果都是真开出来过的。此前整点档卡片切的是任意一期的 D₅–D₉，12 期里只有 1 期
 * 真是整点档 —— 约 92% 的情况下那 5 位数 Milhar Hora 从没开出过，而旁边还挂着
 * 「可去 Etherscan 核对」。
 *
 * <p><b>「哪些期属于整点档」不在前端算。</b>整点档 status 接口本来就返回最近 10 期
 * 真实开奖的期号，用它去筛。在这里复制一份「余数 11」的规则，等于给挑期规则埋了
 * 第二份真相 —— 与本页窗口、赔付、比例一律由后端下发是同一条口径。
 */

/** 归档接口给的期，字段一律宽松 —— 老后端可能缺其中几个。 */
export type RulesExampleCandidate = {
  round_number?: number | string;
  cutoff_ts?: number;
  ends_at?: number;
  starts_at?: number;
  anchors?: Array<{ hash?: string | null } | null | undefined> | null;
};

/** 能不能拿来当例子：3 个锚定区块齐全，且有时刻。 */
export function usableAsExample(round: RulesExampleCandidate): boolean {
  const anchors = (round.anchors || []).filter((anchor) => anchor && anchor.hash);
  const ts = Number(round.cutoff_ts || round.ends_at || round.starts_at || 0);
  return anchors.length >= 3 && ts > 0;
}

/**
 * 按优先级排出可用的候选期：真整点档在前，其余按传入顺序垫后。
 *
 * <p>返回<b>列表</b>而不是单个：派生示例时还可能因为哈希里十进制数字不足 10 个
 * 而失败（`buildRulesExampleFromRound` 返回 null），调用方要能顺着往下试。
 *
 * @param rounds 归档接口的期，调用方需已按<b>从新到旧</b>排好
 * @param hourlyRoundNumbers 整点档 status 返回的真实开奖期号
 */
export function rankRulesExampleRounds<T extends RulesExampleCandidate>(
  rounds: readonly T[],
  hourlyRoundNumbers: Iterable<number | string>,
): Array<{ round: T; hourlyAnchor: boolean }> {
  const hourly = new Set<number>();
  for (const value of hourlyRoundNumbers) hourly.add(Number(value));
  const usable = rounds.filter(usableAsExample);
  const anchored: Array<{ round: T; hourlyAnchor: boolean }> = [];
  const rest: Array<{ round: T; hourlyAnchor: boolean }> = [];
  for (const round of usable) {
    if (hourly.has(Number(round.round_number))) anchored.push({ round, hourlyAnchor: true });
    else rest.push({ round, hourlyAnchor: false });
  }
  return [...anchored, ...rest];
}
